import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const badgeRootClasses = tv({
  base: [
    "box-border",
    "m-0 p-0",
    "text-xs",
    "list-none",
    "relative",
    "inline-block",
    "leading-none",
  ],
});

export const badgeClasses = tv({
  base: [
    "z-auto absolute",
    "p-0 text-white font-semibold font-xs font-sans border-white border",
    "rounded-xl leading-5.5 whitespace-nowrap",
    "text-center  drop-shadow-lg origin-right",
    "flex flex-row flex-wrap place-content-center items-center box-border px-1.5",
  ],
  variants: {
    size: {
      small: ["min-w-4 min-h-4"],
      medium: ["min-w-5 min-h-5"],
      large: ["min-w-6 min-h-6"],
    },
    color: {
      primary: "bg-primary-main",
      secondary: "bg-secondary-main",
      success: "bg-success-main",
      warning: "bg-warning-main",
      info: "bg-info-main",
      error: "bg-error-main",
    },
    shape: {
      circle: ["rounded-full"],
      rectangle: ["rounded-none"],
    },
    placement: {
      "top-right": "top-0 right-0 translate-x-1/2 -translate-y-1/2",
      "top-left": "top-0 left-0 -translate-x-1/2 -translate-y-1/2",
      "bottom-right": "bottom-0 right-0 translate-x-1/2 translate-y-1/2",
      "bottom-left": "bottom-0 left-0 -translate-x-1/2 translate-y-1/2",
      "top-center": "top-0 left-1/2 -translate-x-1/2 -translate-y-1/2",
      "right-center": "right-0 top-1/2 translate-x-1/2 -translate-y-1/2",
      "bottom-center": "bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2",
      "left-center": "left-0 top-1/2 -translate-x-1/2 -translate-y-1/2",
    },
    disableOutline: {
      true: "",
    },
    anchorOrigin: {
      vertical: {
        top: [""],
        right: [""],
        bottom: [""],
        left: [""],
      },
      horizontal: {
        top: [""],
        right: [""],
        bottom: [""],
        left: [""],
      },
    },
  },
  defaultVariants: {
    size: "medium",
    // shape: "circle",
    placement: "top-right",
    color: "primary",
  },
});

export type BadgeVariants = VariantProps<typeof badgeClasses>;
